import { css } from "@emotion/react";
import { jwtDecode } from "jwt-decode";
import { DecodedType, NotiListsType } from "./types";
import { GetProp, Modal, UploadProps } from "antd";
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import axios from "axios";
import { endpoints } from "./api/endpoints";
import { SplashScreen } from "@capacitor/splash-screen";
 //@ts-expect-error
import knayi from 'knayi-myscript';
import { Device } from "@capacitor/device";
import { Dialog } from "@capacitor/dialog";
import { App } from "@capacitor/app";
import config from "./config";
import { Capacitor } from "@capacitor/core";
import { KeepAwake } from "@capacitor-community/keep-awake";

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

export const awake = async() => {
  const {isKeptAwake} = await KeepAwake.isKeptAwake();
  if(!isKeptAwake) {
    KeepAwake.keepAwake();
  }
}

export  const sleep = async () => {
  const {isKeptAwake} = await KeepAwake.isKeptAwake();
  if(isKeptAwake) {
    KeepAwake.allowSleep();
  }
}

export const getDeviceType = () => {
  const width = window.innerWidth;
  if (width < 768) return "mobile";
  if (width < 1024) return "tablet";
  return "desktop";
}

export const getPlatform =  () : 'ios' | 'android' | 'web' => {
  return Capacitor.getPlatform() as 'ios' | 'android' | 'web';
}

export const showPlayStoreModal = () => {
  const isMyanmar = localStorage.getItem('lang') === 'my' ? true : false;
  let title = isMyanmar ? "မရသေးပါ။" : "Not Available!";
  let body = isMyanmar ? "ဤfeature ကို android app တွင်သာရရှီနိုင်ပါသည်။ PlayStore သို့သွားရန်။" : "This feature can only available in android. Go to playstore!";
  Modal.confirm({
    title: title,
    content: body,
    okText: "Playstore",
    onOk() {
      openPlayStore();
    },
  })
}

export const setCurrentVersionNumber = async () => {
  const platform = getPlatform();
  if(platform === 'web') return;
  
  const {version : appVersion} = await App.getInfo();
  localStorage.setItem('appVersion', appVersion);
}

export const customSplit = (str: string) : string[] => {
  // Preserve leading and trailing spaces separately
  const leadingSpaces = str.match(/^\s+/)?.[0] || "";
  const trailingSpaces = str.match(/\s+$/)?.[0] || "";

  //  If string contains only spaces, return them as is
  if (str.trim() === "") {
    return str.split('');
  }

  // Trim input string to remove leading/trailing spaces for processing
  let trimmedStr = str.trim();

  // Split by Myanmar characters and keep the characters
  let result = knayi.syllBreak(trimmedStr, 'unicode', ',').split(",");
  // console.log('result: ', result)

  //to seperate english character and spaces
  result = result.flatMap((part: any) => part.split(/(\s+)/).filter((word: any) => word.length > 0));
  const separateChordAnnotations = (str: string) => {
    const chordPattern = /\[(.*?)\]/g;
    const result = [];
    let lastIndex = 0;

    let match;
    while ((match = chordPattern.exec(str)) !== null) {
      if (match.index > lastIndex) {
        result.push(str.slice(lastIndex, match.index));
      }
      result.push(match[0]);
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < str.length) {
      result.push(str.slice(lastIndex));
    }

    return result;
  };

  // Further split based on spaces and then handle chords and parenthesis
  result = result.flatMap((part: any) => 
    part.split(/(\s+)/).flatMap((subPart : any) => {
      // Check if it's a space; if yes, split it further
      if (/^\s+$/.test(subPart)) {
        return subPart.split('');
      }
      return separateChordAnnotations(subPart);
    })

  );
  // console.log("split: >",  [...leadingSpaces.split(''), ...result, ...trailingSpaces.split('')])
  return [...leadingSpaces.split(''), ...result, ...trailingSpaces.split('')];
};

export const removeChordFromLyrics = (lyrics: string) => {
  let l : string[] = lyrics.split('\n');
  const positions: Record<string, string> = {};
  let removedChordLyrics: string[] = [];

  l.forEach((line, lineIndex) => {
    const words = customSplit(line);
    let newLine = line;

    words.forEach((word, wordIndex) => {
      const chordMatches = word.match(/\[([^\]]+)\]/g);
      if (chordMatches) {
        chordMatches.forEach(chordMatch => {
          const chord = chordMatch.slice(1, -1); // Remove the brackets
          const id = `word_${lineIndex}-${Number(wordIndex)}`;

          positions[id] = chord; 
          newLine = newLine.replace(chordMatch, '');

        });
        words.splice(wordIndex, 1);
      }
    });
    removedChordLyrics[lineIndex] = newLine;
  });
  // console.log("positions", {positions,removedChordLyrics})
  return {positions,removedChordLyrics}
}

export const isEnglishWord = (word: string) => {
  const englishRegex = /^[a-zA-Z]+$/;
  return englishRegex.test(word);
}

export const generateFormattedLyrics = (lyrics: string[], chordPositions: Record<string, string>) => {
  const formattedLyrics =  lyrics.map((line, lineIndex) => {
    const words = customSplit(line);
    const formattedWords = words.map((word, wordIndex) => {
      const positionKey = `word_${lineIndex}-${wordIndex}`;
      if (chordPositions[positionKey]) {
        return `[${chordPositions[positionKey]}]${word}`;
      }
      return word;
    });
    return formattedWords.join('');
  });
  return formattedLyrics.join('\n')
};

export const getDecoded = () => {
  const token : string = localStorage.getItem("token") as string;
  const decoded : DecodedType = jwtDecode(token);
  return decoded
}

export const setFontFamilyAndColor = (lang : string, htmlColor: string) => {
  const fontFamily = `${lang === 'my' ? "'Padauk', sans-serif !important" : 'Arial, sans-serif'}`;

  return css`
      .ant-message-notice-content {
        background-color: cornsilk !important;
      }
      html{
        font-family: ${fontFamily};
      }
      textarea{
        font-family: ${fontFamily};
      }
      div{
        font-family: ${fontFamily};
      }
      button{
        font-family: ${fontFamily};
      }
      h1{
        font-family:  ${fontFamily};
      }

      h2{
        font-family:  ${fontFamily};
      }

      h3{
        font-family:  ${fontFamily};
      }

      h4{
        font-family:  ${fontFamily};
      }

      h5{
        font-family:  ${fontFamily};
      }

      h6{
        font-family:  ${fontFamily};
      }

      html{
        background-color: ${htmlColor};
      }
    `
}

export const generateTikTokCodeVerifier = (length: number = 128): string => {
  const array = new Uint32Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec => ('0' + dec.toString(16)).slice(-2)).join('');
};

export const saveDraft = (chordPro: string, userId: number, singerId: string, songName: string, chordId: string | undefined) => {
  const key = `${userId}_${singerId}_${songName}_${chordId}_draft`;
  const draft = {
    chordPro: chordPro,
    userId: userId,
    singerId: singerId,
    songName: songName,
    lastModified: new Date().getTime()
  };
  localStorage.setItem(key, JSON.stringify(draft));
  localStorage.setItem('chordPro', draft?.chordPro);
}

export const loadDraft = (title: string, content: string, okText: string, cancelText: string, userId: number, songName: string, singerId: string, chordId: string | undefined, ask: boolean = false, navigatedFromDataEntry: boolean = false) : Promise<string> => {
  const key = `${userId}_${singerId}_${songName}_${chordId}_draft`;
  const orgChordPro = navigatedFromDataEntry ? "" : (localStorage.getItem('chordPro') || "");

  const draft = localStorage.getItem(key);
  if (draft) {
    const parsedDraft = JSON.parse(draft);
    const now = new Date().getTime();
    const isExpired = (now - parsedDraft.lastModified) > 3 * 60 * 60 * 1000; // 3 hour
    
    if (isExpired) {
      localStorage.removeItem(key);
      return Promise.resolve(orgChordPro);
    } else {
      if(ask){
        return new Promise((resolve, reject) => {
          Modal.confirm({
            title: title,
            content: content,
            okText: okText,
            cancelText: cancelText,
            centered: true,
            onOk() {
              resolve(parsedDraft?.chordPro);
            },
            onCancel() {
              resolve(orgChordPro);
            },
          });
        });
      }else{
        return Promise.resolve(orgChordPro);
      }
    }
  }
  return Promise.resolve(orgChordPro);
}

export const removeDraft = (userId: number, singerId: string, songName: string, chordId: string = 'none') => {
  const key = `${userId}_${singerId}_${songName}_${chordId}_draft`;
  localStorage.removeItem(key);
}

export const executeCodePush = async () => {
  const platform = await getPlatform();
  if(platform === 'web') return;

  try{
    await CapacitorUpdater.notifyAppReady();
    const {data: result} : any = await axios.get(endpoints.codePush.checkUpdate);
    console.log('checkUpdate result: ',result)
    if (result.code !== '200') {
      SplashScreen.hide();
      return;
    }
    const latest : any = result.data;
    const currentVersion = localStorage.getItem('appBuildNumber') || '1.0.0';
    if(!latest.url || currentVersion === latest.version){
      performImmediatePlayStoreUpdate();
      SplashScreen.hide();
      return;
    }

    console.log(`Current version: ${currentVersion}, New version: ${latest.version}`);
    const version = await CapacitorUpdater.download({
      url: latest.url,
      version: latest.version,
    });
    await CapacitorUpdater.set(version);
    localStorage.setItem('appBuildNumber', latest.version);
  } catch (error) {
    console.log("code push catch error: ",error)
    SplashScreen.hide();
  }
}

export const performImmediatePlayStoreUpdate = async () => {

  const platform = await getPlatform();
  if(platform === 'web') return;

  const remoteBuildVersion = localStorage.getItem('appBuildNumber');
  if(!remoteBuildVersion) return;
  
  const remoteAppVersion =  remoteBuildVersion.split("-")[0];
  const localAppVersion =  (await App.getInfo()).version;

  if(remoteAppVersion !== localAppVersion){
    await Dialog.alert({
      title: 'Update Required',
      message: `A new version of the app is available!`,
      buttonTitle: "Update",
    });
  
    openPlayStore();
  }
};

export const openPlayStore = () => {
  window.open(config.playstoreLink, "_system");
}

export const formatNumber = (num: number): string => {
  if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'; // Billion
  } else if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Million
  } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Thousand
  } else {
      return num.toString(); // Less than 1K, display as is
  }
};

export const addCommaToNumber = (num: number): string => {
  // Remove decimal by truncating the number and then convert to string
  const integerPart = Math.trunc(num).toString();

  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const timeAgo = (serverDate: string): string => {
  const currentDate = new Date();
  const formattedServerTime = new Date(`${serverDate} GMT+0630`).toISOString();
  const date = new Date(formattedServerTime); // Convert to Local Time format
  const diffInSeconds = Math.floor((currentDate.getTime() - date.getTime()) / 1000);

  const minutes = Math.floor(diffInSeconds / 60);
  const hours = Math.floor(diffInSeconds / 3600);
  const days = Math.floor(diffInSeconds / 86400);

  if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;
  if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
  if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  return `${days} day${days !== 1 ? "s" : ""} ago`;
}


export const getNotificationsFromStorage = () : NotiListsType => {
  const storedData = localStorage.getItem("notifications");
  return storedData ? JSON.parse(storedData) : {};
};

export const saveNotificationsToStorage = (notifications: NotiListsType) => {
  localStorage.setItem("notifications", JSON.stringify(notifications));
};

export const fileObjToBase64 = (file: FileType): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
});

export const base64ToFileObj = (base64: string): FileType => {
  const mimeType = base64.split(';')[0].split(':')[1];
  let extension = '';
  if (mimeType.includes('image')) {
      extension = mimeType.split('/')[1]; // 'png', 'jpeg', etc.
  } else {
      extension = 'bin';
  }

  const filename = `file.${extension}`;

  const byteCharacters = atob(base64.split(',')[1]);
  const byteArrays = new Uint8Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays[i] = byteCharacters.charCodeAt(i);
  }

  const blob = new Blob([byteArrays], { type: mimeType });
  const file = new File([blob], filename, { type: mimeType });

  return file as FileType;
};

export const getSlowestScrollStep = async () =>  {
  let highendObj = {
    interval: 40,
    step: 0.4
  };
  let lowendObj = {
    interval: 80,
    step: 0.8
  }
  const deviceInfo = await Device.getInfo();
  const operatingSys = deviceInfo.operatingSystem;
  if(operatingSys === "windows") return lowendObj;
  if(operatingSys === 'ios') return highendObj;
  const osVersion = deviceInfo.osVersion;
  const majorVersion = Number(osVersion.split('.')[0]);
  if(majorVersion >= 10) return highendObj;
  return lowendObj;
}

export const getChordImages = (): Record<any, string[]> => {
  return {
      "A": ["/images/chords/A1.jpg"],
      "Am": ["/images/chords/Am1.jpg"],
      "A#": ["/images/chords/Asharp1.jpg"],
      "A#m": ["/images/chords/Asharpm1.jpg"],
      "Ab": ["/images/chords/Ab1.jpg"],
      "Abm": ["/images/chords/Abm1.jpg"],
      
      "B": ["/images/chords/B1.jpg"],
      "Bm": ["/images/chords/Bm1.jpg"],
      "Bb": ["/images/chords/Bb1.jpg"],
      "Bbm": ["/images/chords/Bbm1.jpg"],
  
      "C": ["/images/chords/C1.jpg"],
      "Cm": ["/images/chords/Cm1.jpg"],
      "C#": ["/images/chords/Csharp1.jpg"],
      "C#m": ["/images/chords/Csharpm1.jpg"],
  
      "D": ["/images/chords/D1.jpg"],
      "Dm": ["/images/chords/Dm1.jpg"],
      "D#": ["/images/chords/Dsharp1.jpg"],
      "D#m": ["/images/chords/Dsharpm1.jpg"],
      "Db": ["/images/chords/Db1.jpg"],
      "Dbm": ["/images/chords/Dbm1.jpg"],
  
      "E": ["/images/chords/E1.jpg"],
      "Em": ["/images/chords/Em1.jpg"],
      "Eb": ["/images/chords/Eb1.jpg"],
      "Ebm": ["/images/chords/Ebm1.jpg"],
  
      "F": ["/images/chords/F1.jpg"],
      "Fm": ["/images/chords/Fm1.jpg"],
      "F#": ["/images/chords/Fsharp1.jpg"],
      "F#m": ["/images/chords/Fsharpm1.jpg"],
  
      "G": ["/images/chords/G1.jpg"],
      "Gm": ["/images/chords/Gm1.jpg"],
      "G#": ["/images/chords/Gsharp1.jpg"],
      "G#m": ["/images/chords/Gsharpm1.jpg"],
      "Gb": ["/images/chords/Gb1.jpg"],
      "Gbm": ["/images/chords/Gbm1.jpg"],
  };
}